<template>
  <div id="home">
    <Header></Header>
    <main>
      <div class="hero">
        <div class="container">
          <div class="hero-content">
            <h1>Conception &amp; Pregnancy Study <span>COVID 19</span></h1>
          </div>
        </div>
      </div>
      <div class="section section-first section-alpha">
        <div class="container">
          <h2>About this study</h2>
          <p>
            We're conducting essential research on how the COVID-19 pandemic
            affects pregnant women and their babies. If you are a pregnant woman
            at any stage of pregnancy, you can take part in the study. This
            includes whether you have just had a positive pregnancy test (even
            if you are unsure what to do about your pregnancy), whether you are
            in the middle of pregnancy, or you are about to have your baby.
          </p>
          <p>
            Thank you for your interest in this study. We have now stopped
            recruiting. We will soon be updating this site with the results of
            the study.
          </p>
        </div>
      </div>
      <div class="section section-beta">
        <div class="container">
          <ul class="images">
            <li>
              <img
                src="@/assets/img/logo-ucl.png"
                alt="University College London logo"
              />
            </li>
            <!-- <li>
              <img
                src="@/assets/img/logo-nhs.png"
                alt="NHS University College London Hospitals logo"
              />
            </li> -->
          </ul>
          <h2>Our team</h2>
          <p>
            The CAP-COVID study was designed by doctors and scientists at
            University College London and University College London Hospital to
            monitor pregnant women in the UK during the COVID 19 pandemic. We
            are interested in women who are currently pregnant and agree to be
            followed-up through a series of surveys to document the outcome of
            their pregnancy.
          </p>
          <p><router-link to="/our-team">See our team</router-link></p>
        </div>
      </div>
      <div class="section section-alpha">
        <div class="container">
          <h2>Your information</h2>
          <p>
            Your personal information is very important to us and we will
            endeavour to take care to protect this information. Your data is
            protected by the European Union's "General Data Protection
            Regulation" (GDPR). It will only be used for health research and
            will not be used for commercial purposes. You can read more about
            how your data will be used, your rights and the steps we take to
            ensure it's protected in our privacy policy.
          </p>
        </div>
      </div>
      <div
        id="modal"
        class="modal"
        v-bind:class="[isModalActive ? 'active' : '']"
      >
        <div class="modal-content">
          <p class="text-right">
            <a href="#app" v-on:click="modalClose" class="back">Cancel</a>
          </p>
          <ol class="steps">
            <li>
              <h3>You are:</h3>
              <ul class="checks">
                <li>Currently pregnant</li>
                <li>Live in the UK</li>
                <li>Aged 18 to 45</li>
              </ul>
            </li>
            <li>
              <h3>
                Read participant information:
              </h3>
              <div class="overflow">
                <p>
                  Scroll through to read about the study,<br />
                  or
                  <router-link to="/participant-information"
                    >view as full page</router-link
                  >
                </p>
                <Info></Info>
              </div>
            </li>
          </ol>
        </div>
      </div>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Info from "@/components/Info.vue";

export default {
  name: "Home",
  components: {
    Header,
    Footer,
    Info
  },
  data: function() {
    return {
      isModalActive: false,
      consentQuestions: []
    };
  },
  methods: {
    modalOpen: function() {
      this.isModalActive = true;
    },
    modalClose: function() {
      this.isModalActive = false;
    }
  }
};
</script>
